<template>
  <div class="backgroundLoginPage">
    <div class="row justify-content-center">
      <div class="col-md-4 col-xs-12">
        <qr-stream
          style="height: 100vh !important"
          :camera="camera"
          :track="paintBoundingBox"
          @decode="onDecode"
        >
          <div style="margin-left: 10px">
            <button
              type="button"
              class="btn btn-light mt-2"
              @click="(isValid = false), turnCameraOn()"
              :style="
                validationPending || validationSuccess
                  ? 'background: transparent; border: 0; z-index: 20;'
                  : 'background: transparent; border: 0; z-index: 20;visibility: hidden;'
              "
            >
              <i class="fas fa-times" style="font-size: 24px"></i>
            </button>
          </div>
          <div
            class="row justify-content-center"
            style="
              position: relative;
              margin-top: -20px !important;
              z-index: 10;
            "
          >
            <div class="col-auto">
              <button
                type="button"
                class="btn btn-lg"
                style="
                  display: flex;
                  align-items: center;
                  color: #fff;
                  background: #000000;
                  border-radius: 20px;
                "
              >
                <img
                  src="../assets/img/scandisini.png"
                  height="30"
                  width="30"
                  class="me-2 img-fluid"
                  alt="..."
                /><span
                  style="
                    font-family: Mada;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 400;
                    text-align: center;
                  "
                  >Scandisini.id</span
                >
              </button>
            </div>
          </div>

          <div v-if="validationSuccess" class="validation-success">
            <div class="row">
              <div class="col-12 text-center">Hasil</div>
              <div class="col-12 text-center">
                {{ result }}
              </div>
              <div class="col-12 text-center">
                <button type="button" class="btn" @click="clicknew(result)" v-if="isValidUrl">
                  Open URL
                </button>
              </div>
            </div>
          </div>
          <div v-if="validationPending" class="validation-pending">
            Loading...
          </div>
          <div class="doughnut" style="margin-top: -75px">
            <p class="p1"></p>
            <p class="p2"></p>
            <p class="p3" style="margin-bottom: 1px"></p>
            <p class="p4" style="margin-bottom: 1px"></p>
          </div>
          <div
            class="card"
            style="
              z-index: 10;
              postion: relative;
              margin-left: auto;
              margin-right: auto;
              width: 85%;
              justify-items: center;
              margin-top: -230px !important;
              border-radius: 20px;
            "
          >
            <div class="card-body">
              <div class="row justify-content-center">
                <div class="col-3 text-center my-1 mx-n1">
                  <div>
                    <img src="../assets/img/mri.png" height="40" width="40" />
                  </div>
                  <div>
                    <span
                      style="
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        white-space: nowrap;
                        font-size: 12px;
                      "
                      >MRI.id</span
                    >
                  </div>
                </div>
                <div class="col-3 text-center my-1 mx-n1">
                  <div>
                    <img
                      src="../assets/img/danmogot.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <span
                      style="
                      margin-left: -6px;
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        white-space: nowrap;
                        font-size: 12px;
                      "
                      >Danmogot.com</span
                    >
                  </div>
                </div>
                <div class="col-3 text-center my-1 mx-n1">
                  <div>
                    <img src="../assets/img/enak.png" height="40" width="40" />
                  </div>
                  <div>
                    <span
                      style="
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        white-space: nowrap;
                        font-size: 12px;
                      "
                      >Enak.id</span
                    >
                  </div>
                </div>
                <div class="col-3 text-center my-1 mx-n1">
                  <div>
                    <img
                      src="../assets/img/cvsaya.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <span
                      style="
                        font-family: Roboto;
                        font-style: normal;
                        white-space: nowrap;
                        font-weight: bold;
                        font-size: 12px;
                      "
                      >CVsaya.id</span
                    >
                  </div>
                </div>
                <div class="col-3 text-center my-1 mx-n1">
                  <div>
                    <img src="../assets/img/epos.png" height="40" width="40" />
                  </div>
                  <div>
                    <span
                      style="
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        white-space: nowrap;
                        font-size: 12px;
                      "
                      >ePos.id</span
                    >
                  </div>
                </div>
                <div class="col-3 text-center my-1 mx-n1">
                  <div>
                    <img src="../assets/img/alere.png" height="40" width="40" />
                  </div>
                  <div>
                    <span
                      style="
                        font-family: Roboto;
                        white-space: nowrap;
                        font-style: normal;
                        font-weight: bold;
                        font-size: 12px;
                      "
                      >Alere.id</span
                    >
                  </div>
                </div>
                <div class="col-3 text-center my-1 mx-n1">
                  <div>
                    <img
                      src="../assets/img/klasik.png"
                      height="40"
                      width="40"
                    />
                  </div>
                  <div>
                    <span
                      style="
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        white-space: nowrap;
                        font-size: 12px;
                      "
                      >Klasik.id</span
                    >
                  </div>
                </div>
                <div class="col-3 text-center my-1 mx-n1">
                  <div>
                    <img src="../assets/img/kada.png" height="40" width="40" />
                  </div>
                  <div>
                    <span
                      style="
                        font-family: Roboto;
                        font-style: normal;
                        font-weight: bold;
                        white-space: nowrap;
                        font-size: 12px;
                      "
                      >Kada.id</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bg-text" style="margin-top: 15px !important; width: 100%">
            <div class="row">
              <div class="col-12 text-center mt-2">
                <span
                  style="
                    font-family: Roboto;

                    font-size: 15px;
                    font-style: normal;
                    white-space: nowrap;
                    font-weight: 700;
                    color: #000;
                  "
                >
                  A Danmogot Company
                </span>
              </div>
            </div>
          </div>
        </qr-stream>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { QrStream } from "vue3-qr-reader";
export default defineComponent({
  name: "PC",
  components: {
    QrStream,
  },
  data() {
    return {
      isValid: false,
      isValidUrl: false,
      camera: "auto",
      newData: {},
      dasar1: "",
      dasar2: "",
      caltinggi1: "",
      caltinggi2: "",
      result: null,
      tinggi: "",
      tinggi2: "",
      width: 0,
      height: 0,
      errLog: "",
      camera2: "rear",
      noRearCamera: false,
      noFrontCamera: false,
    };
  },
  computed: {
    validationPending() {
      return this.isValid === false && this.camera === "off";
    },

    validationSuccess() {
      return this.isValid === true;
    },
    validationUrlSuccess() {
      return this.isValidUrl === true;
    },
    isMobile() {
      return this.width < 960;
    },
    validationFailure() {
      return this.isValid === false;
    },
  },
  methods: {
    onInit(promise) {
      promise.catch().then(this.resetValidationState);
    },
    paintBoundingBox(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const {
          boundingBox: { x, y, width, height },
        } = detectedCode;

        ctx.lineWidth = 2;
        ctx.strokeStyle = "rgba(79, 210, 64, 1)";
        ctx.strokeRect(x, y, width, height);
      }
    },
    getHeight() {
      if (this.isMobile) {
        this.dasar1 = window.innerHeight;
        this.caltinggi1 = this.dasar1 - 150;
        this.tinggi = this.caltinggi1 + "px";
      } else {
        this.dasar2 = window.innerHeight;
        this.caltinggi2 = this.dasar2 - 200;
        this.tinggi = this.caltinggi2 + "px";
      }
      this.tinggi2 = window.innerHeight + "px";
    },
    clicknew(result) {
      this.isValid = false;
      this.turnCameraOn();
      window.open(result);
    },
    resetValidationState() {
      this.isValid = undefined;
    },
    async onDecode(data) {
      if(data != '' || data != null) {
      this.result = data;
      this.turnCameraOff();

      // pretend it's taking really long

      await this.timeout(2000);
      this.isValidUrl = data.startsWith("http");
      this.isValid = true;
      // this.isValidUrl = data.startsWith("http");
      // this.isValid = true;

      // some more delay, so users have time to read the message
      if (!this.isValidUrl) {
        await this.timeout(5000);

        this.turnCameraOn();
      }
      }
    },
    handleResize() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
    },
    turnCameraOn() {
      this.camera = "auto";
    },

    turnCameraOff() {
      this.camera = "off";
    },

    timeout(ms) {
      return new Promise((resolve) => {
        window.setTimeout(resolve, ms);
      });
    },
    switchCamera() {
      switch (this.camera2) {
        case "front":
          this.camera2 = "rear";
          break;
        case "rear":
          this.camera2 = "front";
          break;
      }
    },
  },
  created() {
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    window.addEventListener("resize", this.handleResize);
    this.handleResize();
  },
});
</script>
<style >
.main {
  background-color: #263238;
}
.validation-success,
.validation-failure,
.validation-pending {
  position: absolute;
  width: 100%;
  height: 100%;
  margin-top: -90px;
  backdrop-filter: blur(5px);
  background-color: rgba(255, 255, 255, 0.8);
  text-align: center;
  font-weight: bold;
  font-size: 13px;
  padding: 10px;
  z-index: 11;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
}
.validation-success {
  color: green;
}
.validation-failure {
  color: red;
}
.validation-pending {
  color: rgba(79, 210, 64, 1);
}
.decode-result {
  background-color: #263238;
  font-size: 18px;
  color: green;
  font-weight: bold;
}
.p1 {
  position: absolute;
  margin: 0;
  padding: 5px;
  border-top: 2px solid rgba(79, 210, 64, 1);
  border-left: 2px solid rgba(79, 210, 64, 1);
  top: 0;
  left: 0;
}
.p2 {
  position: absolute;
  margin: 0;
  padding: 5px;
  border-top: 2px solid rgba(79, 210, 64, 1);
  border-right: 2px solid rgba(79, 210, 64, 1);
  top: 0;
  right: 0;
}
.p3 {
  position: absolute;
  border-left: 2px solid rgba(79, 210, 64, 1);
  border-bottom: 2px solid rgba(79, 210, 64, 1);
  padding: 5px;
  margin: 0;
  bottom: 0;
  left: 0;
}
td {
  text-align: center;
}
.p4 {
  position: absolute;
  border-bottom: 2px solid rgba(79, 210, 64, 1);
  border-right: 2px solid rgba(79, 210, 64, 1);
  bottom: 0;
  right: 0;
  margin: 0;
  padding: 5px;
}
.bg-image {
  backdrop-filter: blur(5px);
}

.bg-text {
  background-color: rgba(255, 255, 255, 1); /* Fallback color */
  border-radius: 0;
  width: 100vw;
  position: absolute;
  color: white;
  z-index: 2;
}
#no-background-hover::before {
  background-color: transparent !important;
}
.doughnut {
  position: relative;
  height: 100%;
  width: 100%;
  border-top: 15vh solid rgba(47, 47, 47, 0.5);
  border-bottom: 45vh solid rgba(47, 47, 47, 0.5);
  border-left: 5vw solid rgba(47, 47, 47, 0.5);
  border-right: 5vw solid rgba(47, 47, 47, 0.5);
}
.backgroundLoginPage {
  padding: 0px !important;
  background-color: #f8f8f8 !important;
  background: linear-gradient(0deg, rgba(96, 96, 96, 1), rgba(96, 96, 96, 1));
  background-size: cover;
  position: fixed;
  top: 0;
  left: 0;
  min-width: 100vw;
  min-height: 100vh;
}
</style>